import { FaReact, FaNodeJs, FaHtml5, FaSass } from 'react-icons/fa'
import { IoLogoJavascript } from 'react-icons/io'
import {
  SiJira,
  SiVisualstudiocode,
  SiMercurial,
  SiGit,
  SiAndroidstudio,
  SiIntellijidea,
} from 'react-icons/si'
import { AiFillAndroid } from 'react-icons/ai'
import { ImGit } from 'react-icons/im'
// @ts-ignore
import React from 'react'

interface SkillsType {
  name: string
  icon: any
  link: string
}

export const ToolsData: SkillsType[] = [
  {
    name: 'GIT',
    icon: <SiGit color="#ffffffdc" />,
    link: 'https://www.javascript.com/',
  },
  {
    name: 'Visual Studio Code',
    icon: <SiVisualstudiocode color="#ffffffdc" />,
    link: 'https://www.typescriptlang.org/',
  },
  {
    name: 'Atlassian Jira',
    icon: <SiJira color="#ffffffdc" />,
    link: 'https://reactjs.org/',
  },
  {
    name: 'Android Studio',
    icon: <SiAndroidstudio color="#ffffffdc" />,
    link: 'https://nextjs.org/',
  },
  {
    name: 'IntelliJ Idea',
    icon: <SiIntellijidea color="#ffffffdc" />,
    link: 'https://redux.js.org/',
  },
  {
    name: 'Mercurial',
    icon: <SiMercurial color="#ffffffdc" />,
    link: 'https://nodejs.org/',
  },
]
